export enum QueryableTableSupport {
    Disable = "disable",
    // Load more data as the user pages through
    LoadOnDemand = "load-on-demand",
    // Load all data as quickly as possible
    LoadAll = "load-all",
}
